import { AxiosError } from "axios";
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ITicket } from "../../../../../../interfaces";
import TicketsService from "../../../../../../services/http/services/TicketsService";
import { EmitError } from "../../../../../../utils/EmitError";

export default function useTickets() {

    const [tickets, setTickets] = useState<Array<ITicket>>([]);
    const [page, setPage] = useState<number>(1);
    const [hasMore, setHasMore] = useState(true);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isLoadingTickets, setIsLoadingTickets] = useState<boolean>(false);

    const { id } = useParams();

    const navigate = useNavigate();

    const loadMore = useCallback(async () => {
        if (isLoadingTickets) {
            return;
        }

        const controller = new AbortController();

        try {
            setIsLoadingTickets(true);

            const ticketsData = await TicketsService.listTicketsByGiveawayId(Number(id), page, controller.signal);

            if (ticketsData.records.length === 0) {
                setHasMore(false);
            }

            setTickets((prevState) => [...prevState, ...ticketsData.records]);
            setPage((prevState) => prevState + 1);
            setIsLoadingTickets(false);

        } catch (err) {
            if (err instanceof AxiosError && err.name === "CanceledError") {
                return;
            }

            setIsLoadingTickets(false);
            EmitError(err);
        }

        return () => {
            controller.abort();
        }
    }, [id, page, isLoadingTickets]);

    useEffect(() => {
        if (!id) {
            return;
        }

        const controller = new AbortController();

        async function loadData() {
            try {
                setIsLoading(true);

                const ticketsData = await TicketsService.listTicketsByGiveawayId(Number(id), 1, controller.signal);

                setTickets(ticketsData.records);
                if (ticketsData.records.length < 100) {
                    setHasMore(false);
                }
                setPage((prevState) => prevState + 1);
                setIsLoading(false);
            } catch (err) {
                if (err instanceof AxiosError && err.name === 'CanceledError') {
                    return;
                }

                EmitError(err, true, 'giveawayTickets_asodkaskldasd');
                setIsLoading(false);
            }
        }

        loadData();

        return () => {
            controller.abort();
        }
    }, [id, navigate]);

    return {
        isLoading,
        tickets,
        loadMore,
        hasMore
    }
}
